import compose from 'vegas-js-core/src/functors/compose'

import withConfig   from '../config/withConfig'
import withDialogs  from '../dialogs/withDialogs'
import withLocale   from '../i18n/withLocale'
import withLang     from '../i18n/withLang'
import withSettings from '../settings/withSettings'

export default compose( withDialogs , withConfig, withLang, withLocale, withSettings );
